(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mfs-gift-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfs-gift-navigation')) {
    customElements.define('mfs-gift-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-initialized')) return;
        this.setAttribute('data-initialized', '');
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-mfs-gift-link]');
          if (!link || event.defaultPrevented) return;
          const source = JSON.parse(this.querySelector('[data-current-product]').textContent);
          const form = document.getElementById(this.dataset.formId);
          const sourceVariant = source.variants.find(v => String(v.id) === String(form?.querySelector('[name="id"]')?.value));
          const options = JSON.parse(link.dataset.options);
          const sourceSizeIndex = source.options.findIndex(o => /size/i.test(o));
          const targetSizeIndex = options.findIndex(o => /size/i.test(o));
          if (!sourceVariant || sourceSizeIndex < 0 || targetSizeIndex < 0) return;
          const sizeKey = value => {
            const key = String(value).toLowerCase().replace(/[^a-z0-9]/g, '');
            if (key.includes('superking') || key.includes('usking')) return 'superking';
            if (key.includes('standard') || key.includes('queen')) return 'standard';
            return key;
          };
          const key = sizeKey(sourceVariant.options[sourceSizeIndex]);
          const variants = JSON.parse(link.dataset.variants);
          const matches = variants.filter(v => sizeKey(v.options[targetSizeIndex]) === key);
          const target = matches.find(v => v.available) || matches[0];
          if (!target) return;
          const url = new URL(link.dataset.productUrl, window.location.origin);
          url.searchParams.set('variant', target.id);
          link.href = url.href;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfs-linked-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfs-colour-navigation')) {
    customElements.define('mfs-colour-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-initialized')) return;
        this.setAttribute('data-initialized', '');
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-mfs-colour-link]');
          if (!link || event.defaultPrevented) return;
          const form = document.getElementById(this.dataset.formId);
          const product = JSON.parse(this.querySelector('[data-current-product]').textContent);
          const variantId = form?.querySelector('[name="id"]')?.value;
          const source = product.variants.find(variant => String(variant.id) === String(variantId));
          const sourceSizeIndex = product.options.findIndex(option => option.toLowerCase() === 'size');
          const targetSizeIndex = link.dataset.sizeIndex;
          if (!source || sourceSizeIndex < 0 || targetSizeIndex === '') return;
          const variants = JSON.parse(link.dataset.variants);
          const matches = variants.filter(variant => variant.options[Number(targetSizeIndex)] === source.options[sourceSizeIndex]);
          const target = matches.find(variant => variant.available) || matches[0];
          const url = new URL(link.dataset.productUrl, window.location.origin);
          if (target) url.searchParams.set('variant', target.id);
          link.href = url.href;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfs-pdp-delivery-check"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfs-pdp-delivery')) {
    customElements.define('mfs-pdp-delivery', class extends HTMLElement {
      static state = new Map();
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.input = this.querySelector('[data-postcode]');
        this.result = this.querySelector('[data-result]');
        const options = {signal:this.controller.signal};
        this.querySelector('[data-check]').addEventListener('click', () => this.update(), options);
        this.input.addEventListener('keydown', event => {if(event.key === 'Enter'){event.preventDefault();this.update();}}, options);
        this.input.addEventListener('input', () => { this.area = null; this.constructor.state.delete(this.dataset.form); this.request = (this.request || 0) + 1; this.result.textContent = ''; }, options);
        const saved = this.constructor.state.get(this.dataset.form);
        if(saved) { this.input.value = saved; this.querySelector('details').open = true; this.update(); }
        document.addEventListener('cart:change', event => {
          this.cart = event.detail?.cart || null;
          if(this.area) this.update();
        }, options);
        document.addEventListener('cart:refresh', () => { this.cart = null; if(this.area) this.update(); }, options);
        window.addEventListener('pageshow', () => { this.cart = null; if(this.area) this.update(); }, options);
        document.addEventListener('variant:change', () => {if(this.area) setTimeout(() => this.update(),0);}, options);
        document.addEventListener('change', event => {if(this.area && document.getElementById(this.dataset.section)?.contains(event.target)) setTimeout(() => this.update(),0);}, options);
      }
      disconnectedCallback() {this.controller?.abort(); this.controller = null;}
      classify(value) {
        const match = value.toUpperCase().replace(/\s/g,'').match(/^([A-Z]{1,2})([0-9]{1,2})([A-Z]?)(?:[0-9][A-Z]{2})?$/);
        if (!match) return null;
        const [,prefix,district] = match;
        const n = Number(district);
        const ranges = {AB:[[31,38],[41,56]],FK:[[17,21]],IV:[[1,63]],KA:[[27,28]],KW:[[0,14]],PA:[[20,78]],PH:[[15,50]]};
        if (['JE','GY','IM'].includes(prefix)) return {threshold:18000,label:'crown'};
        if (prefix === 'BT' && n >= 1 && n <= 99) return {threshold:10000,label:'ni'};
        if ((prefix === 'HS' && n >=1 && n <=9) || (prefix === 'KW' && n >=15 && n <=17) || (prefix === 'ZE' && n >=1 && n <=3)) return {threshold:9000,label:'islands'};
        if (ranges[prefix]?.some(([lo,hi]) => n >=lo && n <=hi)) return {threshold:9000,label:'highlands'};
        const validAreas = 'AL B BA BB BD BH BL BN BR BS CA CB CF CH CM CO CR CT CV CW DA DD DE DG DH DL DN DT DY E EC EH EN EX FK FY G GL GU HA HD HG HP HR HU HX IG IP KA KT KW KY L LA LD LE LL LN LS LU M ME MK ML N NE NG NN NP NR NW OL OX PA PE PH PL PO PR RG RH RM S SA SE SG SK SL SM SN SO SP SR SS ST SW SY TA TD TF TN TQ TR TS TW UB W WA WC WD WF WN WR WS WV YO';
        if (validAreas.split(' ').includes(prefix) && n >=0 && n <=99) return {threshold:5000,label:'mainland'};
        return null;
      }
      async update() {
        const request = this.request = (this.request || 0) + 1;
        this.area = this.classify(this.input.value);
        if(!this.area){this.result.textContent=this.config.labels.invalid; return;}
        this.constructor.state.set(this.dataset.form,this.input.value);
        const form = document.getElementById(this.dataset.form);
        const variant = this.config.variants.find(v => String(v.id) === String(form?.querySelector('[name="id"]')?.value));
        if(!variant) return;
        const quantity = Math.max(1,Number(document.getElementById(this.dataset.section)?.querySelector('[name="quantity"]')?.value) || 1);
        this.result.textContent = this.config.labels.loading;
        try {
          if(!this.cart) {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store',signal:this.controller.signal});
            if(!response.ok) throw new Error('Cart unavailable');
            const cart = await response.json();
            if(request !== this.request || !this.isConnected) return;
            this.cart = cart;
          }
          if(this.cart.currency !== 'GBP' || !Number.isFinite(this.cart.total_price)) throw new Error('Cart unavailable');
        } catch(error) {
          if(request === this.request && this.isConnected) this.result.textContent = this.config.labels.error;
          return;
        }
        if(request !== this.request || !this.area) return;
        const projectedTotal = this.cart.total_price + variant.price*quantity;
        const remaining = Math.max(0,this.area.threshold-projectedTotal);
        const shipping = this.area.label === 'mainland' ? 395 : this.area.label === 'crown' ? (projectedTotal >= 12000 ? 1995 : 2995) : 1295;
        const money = amount => new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',maximumFractionDigits:amount%100 ? 2 : 0}).format(amount/100);
        const label = remaining ? this.config.labels.remaining : this.config.labels.met;
        this.result.textContent = label.replace('[region]',this.config.labels[this.area.label]).replace('[threshold]',money(this.area.threshold)).replace('[remaining]',money(remaining)).replace('[shipping]',money(shipping));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
